import { useMediaQuery } from '@mui/material';
import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';

import Icon from 'atoms/Icons/Icon';
import { media } from 'atoms/breakpoints/breakpoints';
import color from 'atoms/colors/colors';

import Flex from 'quarks/Flex';
import Text from 'quarks/Text';

import Slider from 'molecules/Slider/Slider';

import { numberWithCommas } from 'utils/functions';

type SliderProps = {
  setValues: Dispatch<SetStateAction<number[]>>;
};

const SliderPanel: FC<SliderProps> = ({ setValues }) => {
  const [active, setActive] = useState(1);
  const [number, setNumber] = useState<number | number[]>(1200);
  const [cost, setCost] = useState<number | number[]>(0.86);
  const [hours, sethours] = useState<number | number[]>(8);
  const [costHourly, setCostHourly] = useState<number | number[]>(15);
  const [tnumber, setTNumber] = useState<number | number[]>(15);
  const [tcost, setTCost] = useState<number | number[]>(15);
  const [price, setPrice] = useState<number | number[]>(3);
  const [snumber, setSNumber] = useState<number | number[]>(4000);
  const [pcost, setPCost] = useState<number | number[]>(0.09);

  const isMobile = useMediaQuery(media.lg);

  const handleNumber = (_: Event, value: number | number[]) => {
    setNumber(value);
  };
  const handleCost = (_: Event, value: number | number[]) => {
    setCost(value);
  };
  const handlehours = (_: Event, value: number | number[]) => {
    sethours(value);
  };
  const handlecostHourly = (_: Event, value: number | number[]) => {
    setCostHourly(value);
  };
  const handleTCost = (_: Event, value: number | number[]) => {
    setTCost(value);
  };
  const handleTNumber = (_: Event, value: number | number[]) => {
    setTNumber(value);
  };
  const handlePrice = (_: Event, value: number | number[]) => {
    setPrice(value);
  };
  const handleSNumber = (_: Event, value: number | number[]) => {
    setSNumber(value);
  };
  const handlePCost = (_: Event, value: number | number[]) => {
    setPCost(value);
  };

  useEffect(() => {
    setValues([
      Number(number) * Number(cost) + Number(hours) * Number(costHourly),
      200 + (30 / 19) * 0.5 * Number(price) * (Number(tnumber) * 25) + Number(tcost) * (0.5 * Number(tnumber) * 25),
      4800 * (Number(costHourly) / 60) +
        2400 * (Number(costHourly) / 60) +
        Number(snumber) * Number(pcost) +
        50 +
        400 / 12,
    ]);
  }, [number, cost, hours, costHourly, tnumber, tcost, price, snumber, pcost]);

  return (
    <Flex flexDirection="column" width="100%" gap="30px" sm={{ gap: '0px' }} lg={{ flexDirection: 'row', gap: '30px' }}>
      <Flex
        width="100%"
        boxShadow="xl"
        backgroundColor="common-white"
        borderRadius="16px"
        overflowX="hidden"
        overflowY="hidden"
        flexDirection="column"
        sm={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
        lg={{ borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px', width: 'calc((100% - 60px) / 3)' }}
      >
        <Flex
          position="relative"
          width="100%"
          paddingAll={12}
          backgroundColor="green-300"
          fontSize="h6"
          lineHeight="h6"
          textColor="common-white"
          fontWeight="semiBold"
          textAlign="center"
          justifyContent="center"
          sm={{ display: 'none' }}
          lg={{ display: 'flex', fontSize: 'h5', lineHeight: 'h5' }}
          onClick={() => setActive(active === 1 ? 0 : 1)}
        >
          Collections
          <Flex
            position="absolute"
            top="12px"
            right="16px"
            width="32px"
            height="32px"
            borderRadius="50%"
            backgroundColor="common-white"
            alignItems="center"
            justifyContent="center"
            sm={{ display: 'none' }}
          >
            {active === 1 ? (
              <Icon id="plus" size={24} fill={color.green[300]} />
            ) : (
              <Icon id="minus" size={24} fill={color.green[300]} />
            )}
          </Flex>
        </Flex>
        <Flex width="100%" display="none" sm={{ display: 'flex' }} lg={{ display: 'none' }}>
          <Flex
            position="relative"
            width="calc(100% / 3)"
            paddingAll={12}
            backgroundColor="green-300"
            fontSize="textLg"
            lineHeight="textLg"
            textColor="common-white"
            fontWeight="semiBold"
            textAlign="center"
            justifyContent="center"
            onClick={() => setActive(active === 1 ? 0 : 1)}
          >
            Collections
            <Flex
              position="absolute"
              top="14px"
              right="16px"
              width="24px"
              height="24px"
              borderRadius="50%"
              backgroundColor="common-white"
              alignItems="center"
              justifyContent="center"
            >
              {active === 1 ? (
                <Icon id="plus" size={20} fill={color.green[300]} />
              ) : (
                <Icon id="minus" size={20} fill={color.green[300]} />
              )}
            </Flex>
          </Flex>
          <Flex
            position="relative"
            width="calc(100% / 3)"
            paddingAll={12}
            backgroundColor="navy-900"
            fontSize="textLg"
            lineHeight="textLg"
            textColor="common-white"
            fontWeight="semiBold"
            textAlign="center"
            justifyContent="center"
            onClick={() => setActive(active === 2 ? 0 : 2)}
          >
            Routing
            <Flex
              position="absolute"
              top="14px"
              right="16px"
              width="24px"
              height="24px"
              borderRadius="50%"
              backgroundColor="common-white"
              alignItems="center"
              justifyContent="center"
            >
              {active === 2 ? (
                <Icon id="plus" size={20} fill={color.navy[900]} />
              ) : (
                <Icon id="minus" size={20} fill={color.navy[900]} />
              )}
            </Flex>
          </Flex>
          <Flex
            position="relative"
            width="calc(100% / 3)"
            paddingAll={12}
            backgroundColor="blue-600"
            fontSize="textLg"
            lineHeight="textLg"
            textColor="common-white"
            fontWeight="semiBold"
            textAlign="center"
            justifyContent="center"
            onClick={() => setActive(active === 3 ? 0 : 3)}
          >
            Paperless
            <Flex
              position="absolute"
              top="14px"
              right="16px"
              width="24px"
              height="24px"
              borderRadius="50%"
              backgroundColor="common-white"
              alignItems="center"
              justifyContent="center"
            >
              {active === 3 ? (
                <Icon id="plus" size={20} fill={color.blue[600]} />
              ) : (
                <Icon id="minus" size={20} fill={color.blue[600]} />
              )}
            </Flex>
          </Flex>
        </Flex>
        <Flex
          width="100%"
          paddingAll={isMobile || active === 1 ? 32 : 0}
          flexDirection="column"
          gap="24px"
          height={isMobile || active === 1 ? 'fit-content' : '0'}
          overflowX="hidden"
          overflowY="hidden"
        >
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">Number of statements per month</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              {numberWithCommas(Number(number))}
            </Text>
            <Slider
              ariaLabel="number"
              ariaLabelledBy="number"
              defaultValue={1200}
              step={100}
              max={3000}
              min={0}
              onChange={handleNumber}
              css={`
                .MuiSlider-track {
                  color: ${color.green[300]};
                }
              `}
            />
          </Flex>
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">Cost per statement</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              ${cost}
            </Text>
            <Slider
              ariaLabel="cost"
              ariaLabelledBy="cost"
              defaultValue={0.86}
              step={0.02}
              max={5}
              min={0}
              onChange={handleCost}
              css={`
                .MuiSlider-track {
                  color: ${color.green[300]};
                }
              `}
            />
          </Flex>
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">Labor from collections (hours)</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              {hours}
            </Text>
            <Slider
              ariaLabel="hours"
              ariaLabelledBy="hours"
              defaultValue={8}
              step={4}
              max={160}
              min={0}
              onChange={handlehours}
              css={`
                .MuiSlider-track {
                  color: ${color.green[300]};
                }
              `}
            />
          </Flex>
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">CSR hourly cost</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              ${costHourly}
            </Text>
            <Slider
              ariaLabel="hours"
              ariaLabelledBy="hours"
              defaultValue={15}
              step={0.25}
              max={25}
              min={0}
              onChange={handlecostHourly}
              css={`
                .MuiSlider-track {
                  color: ${color.green[300]};
                }
              `}
            />
          </Flex>
        </Flex>
      </Flex>
      <Flex
        width="100%"
        boxShadow="xl"
        backgroundColor="common-white"
        borderRadius="16px"
        overflowX="hidden"
        overflowY="hidden"
        flexDirection="column"
        sm={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
        lg={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px', width: 'calc((100% - 60px) / 3)' }}
      >
        <Flex
          position="relative"
          width="100%"
          paddingAll={12}
          backgroundColor="navy-900"
          fontSize="h6"
          lineHeight="h6"
          textColor="common-white"
          fontWeight="semiBold"
          textAlign="center"
          justifyContent="center"
          sm={{ display: 'none' }}
          lg={{ display: 'flex', fontSize: 'h5', lineHeight: 'h5' }}
          onClick={() => setActive(active === 2 ? 0 : 2)}
        >
          Routing
          <Flex
            position="absolute"
            top="12px"
            right="16px"
            width="32px"
            height="32px"
            borderRadius="50%"
            backgroundColor="common-white"
            alignItems="center"
            justifyContent="center"
            sm={{ display: 'none' }}
          >
            {active === 2 ? (
              <Icon id="plus" size={24} fill={color.navy[900]} />
            ) : (
              <Icon id="minus" size={24} fill={color.navy[900]} />
            )}
          </Flex>
        </Flex>
        <Flex
          width="100%"
          paddingAll={isMobile || active === 2 ? 32 : 0}
          height={isMobile || active === 2 ? 'fit-content' : '0'}
          flexDirection="column"
          gap="24px"
        >
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">Number of employees</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              {tnumber}
            </Text>
            <Slider
              ariaLabel="number"
              ariaLabelledBy="number"
              defaultValue={15}
              step={1}
              max={50}
              min={0}
              onChange={handleTNumber}
              css={`
                .MuiSlider-track {
                  color: ${color.navy[300]};
                }
              `}
            />
          </Flex>
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">Technician hourly cost</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              ${tcost}
            </Text>
            <Slider
              ariaLabel="cost"
              ariaLabelledBy="cost"
              defaultValue={15}
              step={0.25}
              max={30}
              min={0}
              onChange={handleTCost}
              css={`
                .MuiSlider-track {
                  color: ${color.navy[300]};
                }
              `}
            />
          </Flex>
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">Price of fuel per gallon</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              ${price}
            </Text>
            <Slider
              ariaLabel="hours"
              ariaLabelledBy="hours"
              defaultValue={3}
              step={0.05}
              max={10}
              min={0}
              onChange={handlePrice}
              css={`
                .MuiSlider-track {
                  color: ${color.navy[300]};
                }
              `}
            />
          </Flex>
        </Flex>
      </Flex>
      <Flex
        width="100%"
        boxShadow="xl"
        backgroundColor="common-white"
        borderRadius="16px"
        overflowX="hidden"
        overflowY="hidden"
        flexDirection="column"
        sm={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
        lg={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px', width: 'calc((100% - 60px) / 3)' }}
      >
        <Flex
          position="relative"
          width="100%"
          paddingAll={12}
          backgroundColor="blue-600"
          fontSize="h6"
          lineHeight="h6"
          textColor="common-white"
          fontWeight="semiBold"
          textAlign="center"
          justifyContent="center"
          sm={{ display: 'none' }}
          lg={{ display: 'flex', fontSize: 'h5', lineHeight: 'h5' }}
          onClick={() => setActive(active === 3 ? 0 : 3)}
        >
          Paperless
          <Flex
            position="absolute"
            top="12px"
            right="16px"
            width="32px"
            height="32px"
            borderRadius="50%"
            backgroundColor="common-white"
            alignItems="center"
            justifyContent="center"
            sm={{ display: 'none' }}
          >
            {active === 3 ? (
              <Icon id="plus" size={24} fill={color.blue[600]} />
            ) : (
              <Icon id="minus" size={24} fill={color.blue[600]} />
            )}
          </Flex>
        </Flex>
        <Flex
          width="100%"
          paddingAll={isMobile || active === 3 ? 32 : 0}
          height={isMobile || active === 3 ? 'fit-content' : '0'}
          flexDirection="column"
          gap="24px"
        >
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">Number of services per month</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              {numberWithCommas(Number(snumber))}
            </Text>
            <Slider
              ariaLabel="number"
              ariaLabelledBy="number"
              defaultValue={4000}
              step={100}
              max={10000}
              min={0}
              onChange={handleSNumber}
              css={`
                .MuiSlider-track {
                  color: ${color.blue[200]};
                }
              `}
            />
          </Flex>
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">Paper cost</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              ${pcost}
            </Text>
            <Slider
              ariaLabel="cost"
              ariaLabelledBy="cost"
              defaultValue={0.09}
              step={0.01}
              max={0.3}
              min={0}
              onChange={handlePCost}
              css={`
                .MuiSlider-track {
                  color: ${color.blue[200]};
                }
              `}
            />
          </Flex>
          <Flex width="100%" flexDirection="column" gap="6px">
            <Text textColor="gray-700">CSR hourly cost</Text>
            <Text
              fontSize="h5"
              lineHeight="h5"
              fontWeight="bold"
              textColor="gray-900"
              letterSpacing="neg2"
              sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            >
              ${costHourly}
            </Text>
            <Slider
              ariaLabel="hours"
              ariaLabelledBy="hours"
              defaultValue={15}
              step={0.25}
              max={25}
              min={0}
              onChange={handlecostHourly}
              css={`
                .MuiSlider-track {
                  color: ${color.blue[200]};
                }
              `}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SliderPanel;
